const studentApplyInvoice = {
  path: 'studentApplyInvoice',
  component: resolve => require(['../../../../components/pages/signUp/studentApplyInvoice'], resolve)
}
export default studentApplyInvoice
